export const UPDATE_STARTUP_ADDRESS_REQUEST = 'startup/UPDATE_STARTUP_ADDRESS_REQUEST';
export const UPDATE_STARTUP_ADDRESS_SUCCESS = 'startup/UPDATE_STARTUP_ADDRESS_SUCCESS';
export const UPDATE_STARTUP_ADDRESS_FAILURE = 'startup/UPDATE_STARTUP_ADDRESS_FAILURE';
